import { ApiClient } from '../client'
import { 
  User, 
  CreateUserRequest, 
  UpdateUserRequest,
  PaginatedResponse,
  ApiResponse 
} from '../types'

export class UserApi {
  constructor(private client: ApiClient) {}

  async list(params: { 
    organisationId?: string
    status?: string 
  } = {}): Promise<User[]> {
    const response = await this.client.get<any>('/v1/users', params)
    // Backend returns { success: true, data: { users: [...], pagination: {...} } }
    // Extract just the users array since pagination isn't used for small datasets
    return response?.data?.users || response?.users || []
  }

  async get(userId: string): Promise<User> {
    const response = await this.client.get<any>(`/v1/users/${userId}`)
    return response?.data || response
  }

  async create(userData: CreateUserRequest): Promise<ApiResponse<User>> {
    return this.client.post<ApiResponse<User>>('/v1/users', userData)
  }

  async update(userId: string, userData: UpdateUserRequest): Promise<ApiResponse<User>> {
    return this.client.patch<ApiResponse<User>>(`/v1/users/${userId}`, userData)
  }

  async delete(userId: string): Promise<void> {
    return this.client.delete<void>(`/v1/users/${userId}`)
  }

  async invite(data: {
    email: string
    given_name: string
    surname: string
    role_id: string
    organisation_id?: string
  }): Promise<ApiResponse<{ user_id: string; invitation_sent: boolean }>> {
    return this.client.post<ApiResponse<any>>('/v1/users/invite', data)
  }

  async resendInvite(userId: string): Promise<ApiResponse<{ success: boolean }>> {
    return this.client.post<ApiResponse<any>>(`/v1/users/${userId}/resend-invite`, {})
  }

  async getRoles(): Promise<Array<{
    role_id: string
    role_name: string
    description: string
    permissions: string[]
  }>> {
    const response = await this.client.get<any>('/v1/users/roles')
    return response?.data || response
  }

  async updateRole(userId: string, roleId: string): Promise<ApiResponse<User>> {
    return this.client.patch<ApiResponse<User>>(`/v1/users/${userId}/role`, { role_id: roleId })
  }
}
